export const formLocales = {
  ap: {
    nameInvalid: "Please enter a valid Contact Name.",
    firstNameInvalid: "Please enter a valid First Name.",
    lastNameInvalid: "Please enter a valid Last Name.",
  },

  password: {
    emailInvalid: "Please enter a valid email id.",
    emailRequired: "Email field cannot be empty, please enter a valid mail id.",
    userName: "Username or Email address",
  },
  role: {
    admin: "Super Admin",
    confirmPassword: "Confirm Password",
    confirmPasswordRequired: "Confirm password is required",
    confirmPasswordMatch: "Confirm password does not match with password.",
    dso: "DSO/DPO",
    email: "Email",
    emailInvalid: "Please enter a valid email id.",
    emailRequired: "Email field cannot be empty, please enter a valid mail id.",
    job: "Role",
    jobCategories: "Job categories",
    jobRequired: "Please select at least one job category to continue.",
    module: "Module",
    name: "Name",
    nameRequired: "Name field cannot be empty, please enter user's name.",
    officeType: "Office type",
    officeTypeRequired: "Please select an office type to continue.",
    parentOfficeRequired: "Please select a parent office to continue.",
    pleaseSelect: "Please select a value",
    password: "Password",
    passwordRequired: "Password is required",
    passwordValid:
      "Must contain a minimum of 8 characters, 1 uppercase letter, 1 numeric digit & 1 special character.",
    private: "PP/Multi",
    removeUserMessage: "Remove user successfully",
    role: "Assign Role",
    roleRequired: "Please select a role to continue.",
    saveMessage: "User creation has been completed successfully.",
    state: "State",
    stateOfOperation: "State of operation",
    stateRequired: "Please select at least one state to continue.",
    type: "Type",
    updateMessage: "Changes saved successfully.",
  },
};
export const locales = {
  ach: "DEBIT Authorization Form -ACH",
  action: "Action",
  add: "Add",
  address: "Address",
  addChildOffice: "Add Child Office",
  additionalInformation: "Additional information",
  all: "All",
  approve: "Approve",
  billRate: "Bill rate",
  billRatePositive: "Rate must be positive",
  billRateRequired: "Bill rate is required",
  clear: "Clear",
  dateType: "Date type",
  dns: "Do Not Send",
  dnsConfirm:
    "Professional(s) in the selected list are included in this office’s “Do Not Send” list. Please remove the users to proceed.",
  dnsProfessionalConfirm:
    "Selected professional(s) have marked this office as Do Not Send. Please remove the users to proceed.",
  dnsOfficeProfessionalConfirm:
    "Both the office and the professional(s) have mutually marked each other as ‘Do Not Send’ list. Please remove the users to proceed.",
  email_valid:
    "This doesn't look like a real email address. Communications may be missed.",
  currentBillRate:
    "To update the current bill rate, click on the Current bill rate field and enter the new amount.",
  descriptionValid: "Description is required",
  download: "Download",
  doNotSent: {
    email: "Email",
    heading: "Do Not Send",
    id: "Id",
    name: "Name",
    tagByName: "Tag By Name",
    phone: "Phone",
    revertConfirm:
      "Are you sure you want to remove this user from do not send?",
    revertSuccess: "User removed from do not send successfully",
  },
  generateReport: "Generate Report",
  history: "History",
  reject: "Reject",
  VersionUpdateFailed: "Profile update failed",
  VersionUpdateSuccess: "Profile updated successfully",
  addConfirmText:
    "You are about to update a user to DDS admin portal an email is send to the user.",
  addHeader: "Assign New Role",
  addNew: "+ Add New",
  addOffice: "Add another office",
  addOfficeMerge: "Add Office",
  addProfessional: "Add Professional",
  additionalSkills: "Additional Skills",
  agreementTest: "Agreement and Consent to Drug and /or Alcohol Testing",
  licenceAlreadyExists: "License number already exists",
  allReadyAPprove:
    "You do not have permission to edit this profile because it is currently in approved status.",
  BillingAddress: "Choose Billing Address",
  bVaccine:
    "I hereby certify that I have read this information and I have received the complete three dose series of the Hepatitis B vaccine.",
  bVaccineDate: "Please select the vaccinated date.",
  cancel: "Cancel",
  checkCompleted: "Checking completed.",
  checkLinkText:
    "We are checking, the child office contract and parent office contracts are matching or not and also the child is independent office or not.",
  checkMergeText:
    "We are checking for ongoing jobs with people assigned, pending timesheet entries, invoices pending.",
  childOffice: "Child Office",
  childPaymentModel: "Child Payment Model",
  mixedPaymentModel: "Mixed Payment Model",
  parentPaymentModel: "Parent Payment Model",
  paymentMethod: "Payment Method",
  billingModel: "Billing Model",
  childOfficeCancel: "Are you sure want to cancel",
  childOfficeId: "Child Office ID",
  chooseTo: "Choose To",
  city: "City",
  close: "Close",
  confirm: "Confirm",
  continue: "Continue",
  completedVaccine:
    "I hereby certify that I have read this information and I have elected to receive the Hepatitis B vaccine and/or I am in the process of receiving the complete three dose series of the Hepatitis B vaccine.",
  createWelcomeLabel: "Send an email to the user regarding profile creation.",
  createdWelcomeMail:
    "You have created a profile. A welcome mail will be sent to the user regarding this.",
  creditCard: "Credit Card Authorization",
  currentWork: "Current Employer",
  date: "Date",
  dateOfVaccination: "Date of completion of vaccination series",
  description: "Description",
  document: "Document",
  documents: {
    addText: "Are you sure, you want to add this document?",
    deleteText: "Are you sure, you want to delete this document?",
    deleteMessage: "Document deleted successfully",
    selectFile: "Please select a file before submitting.",
    uploadSuccess: "Document uploaded successfully",
  },
  edit: "Edit",
  editHeader: "Edit Role",
  editPaymentHeader: "Edit Payment Method",
  exhibitb: "EXHIBIT B Referral Based Staff (Auxiliary Staffing Only)",
  exhibitc: "EXHIBIT C : Payroll Services",
  exhibit1: 'EXHIBIT A-1 : Full Service "All Inclusive" Plan – Auxiliary Staff',
  exhibit2: 'EXHIBIT A-2 : Full Service "All Inclusive" Plan - Dentists',
  expert: "Expert",
  expirationDate: "Expiration Date",
  expirationDateRequired: "Expiration Date is required.",
  email: "Email",
  fcra: "Background and FCRA",
  fillPrevious: "To fill this, please complete all previous forms",
  fileType:
    "Note: Documents should be uploaded either as a PDF file or as a JPG or PNG image files.",
  fileTypeNote:
    "Note: Documents should be uploaded either as a PDF, DOC, or DOCX file, or as JPG or PNG image files.",
  firstAssignment: "First Assignment",
  pdfFileType: "Note: Documents should be uploaded as a PDF file.",
  forgotPassword: "Forgot Password",
  independentOffice:
    "The child office and parent office contracts are matching and also the child is independent office.",
  invalidEmail: "Invalid Email",
  identificationId: "Government Photo ID / Passport / Driving License",
  link: "Link",
  linkDso: "Link an existing DSO/DPO",
  linkPrivate: "Link",
  jobLastPosted: "Job Last Posted",
  jobRole: "Job role",
  jobValid: "Job role is required",
  getNewPassword: "Get New Password",
  hbv: "Hepatitis B(HBV) Vaccination Declaration/Declination Form",
  headOffice: "Head Office",
  hippaPrivacy: "HIPPA Privacy Training Module",
  id: "Id",
  identification: "Identification",
  identificationResume: "Identification & Resume",
  license: "License",
  licenseNumber: "License Number",
  licenseNumberRequired: "License Number is required.",
  invalidLicenseNumber: "Please enter a valid license number.",
  licenseRequired: "File is required",
  linkOrMerge: "Link or Merge Office",
  linkPrivateOffice: "Link PP/Multi",
  linkSuccess: "Successfully linked with the selected DSO/DPO.",
  linkPrivateSuccess: "Successfully linked with the PP/Multi.",
  logs: "Logs",
  loading: "loading",
  loadingPdf: "Loading PDF...",
  lostData:
    "Are you sure you want to cancel, All unsaved changes will be lost.",
  markAsInvalid: "Mark as Invalid",
  markAsValid: "Mark as Valid",
  markAsInvalidMessageSuccess:
    "Selected profile(s) have been marked as invalid successfully.",
  markAsValidMessageSuccess:
    "Selected profile(s) have been marked as valid successfully.",
  markAsInvalidText:
    "Are you sure you want to mark the selected profile(s) invalid?",
  markAsValidText:
    "Are you sure you want to mark the selected profile(s) valid?",
  multipleContactSelectionNote:
    "Deselect all valid users from the selection to continue.",
  marketPlace: "Marketplace and Handbook",
  masterAgreement: "Master Full Service Agreement",
  merge: "Merge",
  mergeDso: "Merge Private office with DSO/DPO",
  mergeDsoTitle: "Merge with DSO/DPO",
  mergeWithSelectedDso:
    "So, private office can be merged with the selected DSO/DPO.",
  mergeSuccess: "Successfully merged with the selected DSO/DPO.",
  milesRequired: "To calculate mile radius zip code is required",
  minute: "Min",
  mailSend: "Mail has been sent successfully.",
  moderate: "Moderate",
  monthlyInvoiceStatement: "Monthly invoice statement",
  more: "more",
  na: "NA",
  name: "Name of User",
  next: "Next",
  npiNumber: "NPI Number",
  npiNumberRequired: "NPI Number is required.",
  notesLabel: "Notes",
  no: "No",
  noData: "No data available",
  noInvoiceFoundPeriod: "No invoice records found for the given period",
  noDependencies: "No dependencies are found.",
  noNotification: "No notifications found.",
  novice: "Novice",
  pdfView: "PDF Preview",
  preview: "Preview",
  professionalName: "Professional name",
  professionalNameValid: "Professional name is required",
  profileSubmitSuccess: "Profile submitted successfully",
  profileSubmitFailed: "Profile submission failed",
  revert: "Revert",
  office: "Office",
  officeInfo: "Office Info",
  officeName: "Office Name",
  officeReport: "Office Report",
  officeSuccess: "Office Added successfully",
  ok: "Ok",
  onlyPDF: "Note: Documents should be uploaded as a PDF file.",
  others: "Others",
  otherSoftwareRequired: "please enter other software experience.",
  optionRequired: "Please select at least one option to continue.",
  overdue: "Over due",
  parentOfficeId: "Parent Office ID",
  passwordUpdateMessage: "Password reset has been completed successfully.",
  pdfRequired: "Please upload a document in PDF format only.",
  choosePayScale: "Choose the pay scale table",
  choosePayScaleType: "Choose pay scale",
  paymentConfirmation:
    "Are you sure you want to change the payment method of this office?",
  paymentAgreementReleased: "The payment agreement was released.",
  paymentSuccess: "Payment method updated successfully",
  permission: "Details and permissions",
  pleaseConfirm: "Please Confirm!",
  pleaseConfirmTextAdd: "Are you sure, you want to add this document ?",
  pleaseConfirmTextDelete: "Are you sure, you want to delete this document ?",
  pleaseEnter: "Please enter",
  pleaseSelect: "Please select value",
  pleaseSelectItem: "Please select",
  pleaseSelectOffice: "Please select office.",
  pleaseSelectPayScale: "Please select pay scale",
  pleaseSelectPayScaleValue: "Please select",
  pleaseWait: "Please wait!",
  personalDetails: "Personal Details",
  present: " Present",
  previous: "Previous",
  primaryRole: "Primary Role",
  primarySkills: "Primary Skills",
  professional: "Professional",
  prophyLength: "How long are the prophy lengths (minutes)?",
  readLess: "Read less",
  readMore: "Read more",
  referral: "Referral Management",
  referralComponent: {
    action: "Actions",
    addReferral: "Add Referral",
    cancel: "Cancel",
    category: "Category",
    code: "Unique Code",
    createCategory: "Referral category created successfully.",
    createSubCategory: "Referral subcategory created successfully.",
    disable: "Disable",
    disableContent: "Are you sure you want to disable this referral category?",
    disableCategory: "Referral category disabled successfully.",
    disableSubCategory: "Referral subcategory disabled successfully.",
    disableSubCategoryContent:
      "Are you sure you want to disable this referral subcategory?",
    enable: "Enable",
    enableContent: "Are you sure you want to enable this referral category?",
    enableCategory: "Referral category enabled successfully.",
    enableSubCategory: "Referral subcategory enabled successfully.",
    enableSubCategoryContent:
      "Are you sure you want to enable this referral subcategory?",
    generateCode: "Generate Code",
    hasSubCategory: "Has subcategory",
    referralCategories: "Referral Categories",
    referralMapSuccess: "Referral mapped successfully",
    mapReferral: "Map Referral",
    no: "No",
    noReferralCategories: "No Referral Categories posted yet.",
    number: "SI.No",
    pleaseEnterReferralCode: "Please enter a unique code",
    pleaseEnterReferralName: "Please enter a referral name",
    pleaseSelectCategory: "Please select a category",
    pleaseSelectSubCategory: "Please select a subcategory",
    pleaseSelectUniqueCode: "Unique code is required",
    referralHeader: "Referral Categories",
    referralName: "Referral Name",
    selectCategory: "Select Category",
    selectSubcategory: "Select Subcategory",
    subcategory: "Subcategory",
    subcategories: "Subcategories",
    submit: "Submit",
    view: "View",
    yes: "Yes",
    infoMsg:
      "A main category with subcategories will appear in profile mapping/update only if at least one subcategory is added & enabled",
  },
  rejectReasonError: "Please provide a valid reject reason.",
  releaseContractSuccess: "Released contract successfully",
  releaseAgreementsSuccess: "Released agreement successfully",
  remove: "Remove",
  reports: "Reports",
  resetMessage:
    "Please check the user email for a password reset link if their DDS account exists.",
  resetPassword: "Reset Password",
  resetPasswordFailed: "Failed to reset the password. Please try again.",
  resetPasswordSuccess: "Password reset link sent successfully.",
  resetPasswordTextOne:
    "Upon clicking the confirm button, an email will be sent to",
  resetPasswordTextTwo: "with instructions for resetting the password.",
  resetPasswordTitle:
    "Are you sure you want to initiate the  password reset process for this user?",
  removeUserText: "Are you sure you want to remove the user?",
  role: "Role Assigned",
  roleAndLicense: "Role & Dental License",
  roleHeader: "Role Management",
  roleLabel: "Role Management",
  roleLabelReport: "Role",
  sameOffice: "Selected office and linking office cannot be the same.",
  save: "Save",
  saveAndClose: "Save and Close",
  saveAndContinue: "Save and Continue",
  secondaryRole: "Secondary Role",
  select: "Select",
  selected: "Selected file:",
  selectDateRange: "Select date range",
  selectEndDate: " - Select end date",
  selectDate: "Select a date",
  selectRange: "Select date range",
  selectRangeLabel: "Select Range",
  selectedOffice: "Select Office",
  selectedConfirmDso:
    "Are you sure, you want to link with the selected DSO/DPO?",
  selectedConfirmPrivate:
    "Are you sure, you want to link with the selected PP/Multi?",
  selectedDso: "So, child office can link with the selected DSO/DPO.",
  selectedPrivate: "So, child office can link with the selected PP/Multi.",
  selectedMergeDso:
    "Are you sure, you want to merge with the selected DSO/DPO?",
  selectPlaceHolder: "Select...",
  selectReason: "Please select reason.",
  setPassword: "Set Password",
  skills: "Skills",
  skillLevel: "Please select your skill level.",
  solicitation: "Confidentiality and Non Solicitation Agreement",
  softwareExperience: "Software Experience",
  specialitySkills: "Specialty Skills",
  staffId: "Id",
  state: "State",
  statement: "Statement",
  status: "Status",
  submit: "Submit",
  subType: "Sub Type",
  timeSheetApproved:
    "This timesheet has already been approved by the office. Any changes submitted will be shared with the respective professional and office",
  to: "TO",
  totalAmount: "Total Amount",
  toContinue: "to continue",
  totalHours: "Total hours",
  totalHoursValid: "Total hours is required",
  totalPositiveValid: "Hours must be positive",
  type: "Type",
  unAssignSuccessMessage: "Recruiter Unassigned Successfully",
  updateConfirmText:
    "You are about to add a user to DDS admin portal, an email will be sent to the user.",
  updateContract: "Updated contract successfully",
  updateAgreement: "Updated agreement successfully",
  updateMail:
    "You have updated the profile. An alert will be sent to the user regarding the update.",
  updateRole: "Update new role",
  updateWelcomeLabel: "Send an email to the user regarding the update.",
  updateWelcomeMail:
    "You have updated the profile. A welcome mail will be sent to the user regarding this.",
  upload: "Upload",
  uploadFile: "Upload File",
  uploadDocument: "Upload Document",
  uploadHeader: "Upload",
  userName: "Name of User",
  vaccineSeries:
    "I have opted out of receiving the Hepatitis B vaccination series.",
  vaccineSeriesRisk:
    "I understand that due to my occupational exposure to blood or other potentially infectious materials (OPIM),I may be at risk of acquiring Hepatitis B Virus (HBV) infection. I have been given the opportunity to be vaccinated with the Hepatitis B vaccine at no charge to myself, however, I have declined this vaccine at this time. I understand that by declining this vaccine I continue to be at risk of acquiring Hepatitis B, a serious disease. If, in the future, I continue to have occupational exposure to blood or OPIM and I want to be vaccinated with Hepatitis B vaccine, I can receive the vaccination series at no charge to me.",
  vaccineSeriesRiskRequired: "Please acknowledge the vaccination waiver.",
  view: "View",
  verify: "Verify",
  workHistory: "Work History",
  workHistoryAndResume: "Work History & Resume",
  yes: "Yes",
  zipCodeError: "Please enter a valid zip code.",
  skillUpdateMsg: "You have updated the skills.",
  softwareExperienceUpdateMsg: "You have updated the software experience.",
  viewAssignments: "View Assignments",
  viewManualInvoice: "View Manual Invoices",
  prospectType: "Prospect Type",
  fileSizeMoreThanError:
    "File size exceeds the limit of 20 MB. Please choose a file of size smaller than 20 MB.",
  mainCategory: "Main Category",
  subCategory: "Sub Category",
  referralCode: "Referral Code",
  updatedBy: "updated by",
};

export const localesForm = {
  aboutYourPractice: {
    adult: "Adult",
    children: "Children",
    srp: "SRP",
    clients: "Clients",
    employeeReferral: "Employee Referral",
    haveYouWorkedWithStaffingCompany:
      "Have you worked with a staffing company before?",
    howDidYouHearAboutUs: "How did you hear about DDS?",
    howManyOperatories: "How many operatories?",
    howManyOperatoriesRequiredField:
      "Please enter the operatories count to continue.",
    howManyPractice: "How many practices are within your organization/DSO/DPO?",
    howManyPracticeRequiredField: "Please enter the practice count.",
    howToHearAboutUs: "How did you hear about DDS?",
    howToHearAboutUsRequiredField: "Please provide a valid answer.",
    staffingCompanyRequired: "Please enter the staffing company.",
    hygiene: "Does your organization run double hygiene?",
    immediateNeed: "Does your organization have any immediate needs?",
    invalidOption: "Please select a valid option.",
    jobBoards: "Job Boards",
    no: "No",
    numberOfLocationsRequired: "Please enter the number of locations.",
    numberRequired: "Please enter a valid number.",
    optionalRequiredField: "Please select Yes/No to continue.",
    otherSoftware: "Other software utilized",
    position: "What is the duration of this position?",
    positionRequiredField: "Please select a position to continue.",
    requiredField: "This field is required.",
    school: "School",
    schoolName: "School Name",
    socialMedia: "Social Media",
    software: "What software does your organization utilize?",
    softwareRequiredField: "Please select at least one software to continue.",
    staffingCompanyImportant:
      "When working with a staffing company, what is most important to you?",
    staffingCompanyPosition:
      "What position did the staffing company assist you with?",
    staffingCompanyImportantRequiredField:
      "Please select the role to continue.",
    tradeShow: "Trade Show",
    typeOfPractice: "What type of practice?",
    validSoftware: "Please enter a valid software",
    whatPosition: "If so, for what position?",
    whatPositionRequiredField: "Please select the position to continue.",
    whichOne: "If so, which one?",
    xray: "Does your organization use digital X-rays? ",
    yes: "Yes",
  },
  achFelid: {
    labelAccountHolder: "Account Holder",
    labelAccountNumber: "Account Number",
    labelAliasEmail: "Alias",
    doingBusiness: "Doing Business as (If applicable)",
    taxStatus: "Tax Status",
    labelBankName: "Bank Name",
    labelBankRouting: "Bank Routing #",
    labelConfirmEmail: "Confirm Email",
    labelType: "Type",
    invalidBankRouting: "Routing number must be 9 digits",
    invalidAccountHolder:
      "Account holder number must be between 6 and 17 digits",
    invalidConfirmEmail: "Please enter a valid email address",
    requiredAccountHolder: "Please enter account holder",
    invalidAccountHolderName: "Please enter a valid account holder name",
    requiredAccountNumber: "Please enter account number",
    requiredAliasEmail: "Please enter alias",
    requiredTaxStatus: "Please select tax status",
    invalidAliasEmail: "Please enter a valid value",
    requiredBankName: "Please enter bank name",
    invalidBankName: "Please enter a valid bank name",
    requiredBankRouting: "Please enter bank route",
    requiredConfirmEmail: "Please enter confirm email",
  },
  ap: {
    contactDirectLineLabel: "Mobile Number",
    contactEmailLabel: "Email Id",
    contactNameLabel: "Contact Name",
    lastNameLabel: "Last Name",
    invalidDirectLine: "Please enter a valid Mobile Number.",
    invalidEmail: "Please enter a valid email id.",
    requiredContactName: "Please enter First Name to continue.",
    requiredDirectLine: "Please enter an Mobile Number to continue.",
    requiredEmail: "Please enter an email id to continue.",
    firstName: "First Name",
  },
  backroundAndFcra: {
    drivingLicense: "Drivers's License Number",
    invalidLicense: "Please enter a valid license number",
    labelAddress1: "Address Line 1",
    labelAddress2: "Address Line 2",
    labelCity: "City",
    labelCrime:
      "Have you ever been convicted of crime other than minor traffic offenses?",
    labelCurrentAddressLive:
      "How long have you lived at your current address? (Years)",
    labelDate: "date",
    labelMinnesota:
      "Send a copy of consumer report(Minnesota & Oklahoma applicants):",
    labelName: "Name",
    labelPreviousName: "Previous Names Used(within the past 7 years)",
    labelSsnName: "SSN (XXX-XX-XXXX)",
    labelState: "state",
    labelZipCode: "Zip Code",
    requiredAddress1: "Please enter Address Line 1.",
    requiredAddress2: "Please enter Address Line 2.",
    requiredCity: "Please enter city.",
    requiredCurrentAddressLive: "Please enter current address duration.",
    requiredDrivingLicense: "Please enter Drivers's License Number.",
    requiredDate: "Please select date.",
    requiredName: "Please enter name.",
    requiredPreviousName: "Please enter previous name.",
    invalidPreviousName: "Please enter valid previous names.",
    requiredSsnName: "Please enter SSN.",
    requiredState: "Please enter state.",
    requiredZipCode: "Please enter zip code.",
  },
  billing: {
    addressLine1Label: "Office Address Line 1",
    addressLine2Label: "Office Address Line 2",
    cityLabel: "City",
    officeNameLabel: "Office Name",
    stateLabel: "State/Region",
    zipCodeLabel: "Zip code",
  },
  common: {
    checking: "Checking",
    document: "Document",
    savings: "Savings",
    yes: "Yes",
    no: "No",
    requiredDocument: "Please upload document",
  },
  contact: {
    emailLabel: "Email Id",
    invalidEmail: "Please enter a valid email id.",
    invalidMobile: "Please enter a valid mobile number.",
    mobileLabel: "Mobile Number",
    nameLabel: "Contact Name",
    lastNameLabel: "Last Name",
    firstName: "First Name",
    phoneNumberExists: "Phone number already exists",
    emailExists: "Email id already exists",
    requiredEmail: "Please enter contact email id.",
    requiredMobile:
      "Mobile number cannot be empty. Please enter mobile number.",
    requiredName: "Please enter first name.",
    requiredLastName: "Please enter a valid last name.",
    roleLabel: "Role",
    roleManager: "Office Manager",
  },
  creditCard: {
    labelAccountNumber: "Account Number",
    labelExpiryDate: "Expiry Date",
    labelSecurityCode: "Security Code",
    labelType: "Type",
    invalidExpiryDate: "Please enter a valid expiry date (MM/YYYY)",
    invalidAccountNumber: "Account number must be between 6 and 17 digits.",
    invalidSecurityCode: "Please enter a valid security code",
    requiredAccountNumber: "Please enter account number",
    requiredExpiryDate: "Please enter expiry date",
    requiredSecurityCode: "Please enter security code",
    invalidMessage: "Please enter a valid expiry date",
  },
  dentalFacility: {
    labelName: "Name of Dental Facility",
  },
  identificationAndResume: {
    errors: {
      governmentFileIdRequired: "Please upload your id",
      governmentIdRequired: "Please enter your id.",
      issuedByRequired: "Please fill in the 'issued by' field.",
      uploadResume: "Please upload your CV/Resume",
      invalidGovernmentId: "Please enter a valid id.",
      invalidPassportNumber: "Please enter a valid passport number.",
      invalidSSNNumber: "Please enter a valid SSN number.",
      invalidLicenseNumber: "Please enter a valid license number.",
      invalidIssuedBy: "Please enter a valid value.",
      passportNumber: "Please enter passport number",
      ssnNumber: "Please enter SSN",
      licenseNumber: "Please enter license number",
      passport: "Please upload your passport",
      ssn: "Please upload your SSN",
      license: "Please upload your license",
      pcInt: "Please enter PC int",
      invalidPCInt: "Please enter a valid PC int",
    },
    labels: {
      governmentFileId: "Upload ID",
      governmentId: "ID",
      issuedBy: "Issued by",
      uploadResume: "Upload CV/Resume",
      passportNumber: "Passport Number",
      uploadPassport: "Upload Passport",
      ssn: "SSN",
      uploadSsn: "Upload SSN",
      licenseNumber: "License Number",
      uploadLicenseNumber: "Upload License",
      passport: "Passport",
      pcInt: "PC int",
      ssnAndLicense: "SSN and License",
    },
    note: "Please upload a clear photo of your valid Government issued ID/ Drivers License. This information will only be used for verification purpose.",
  },
  office: {
    addressLine1Label: "Office Address Line 1",
    addressLine2Label: "Office Address Line 2",
    cityLabel: "City",
    emailLabel: "Primary Email",
    invalidEmail: "Please enter a valid email id.",
    nameInvalid: "Please enter a valid first name.",
    invalidName: "Please enter a valid name.",
    invalidOfficeName: "Please enter a valid office name.",
    invalidStaffingCompany: "Please enter a valid staffing company name.",
    invalidTelephone: "Please enter a valid office number.",
    invalidPhoneNumber: "Please enter a valid phone number.",
    invalidAddress: "Please enter a valid address.",
    labelName: "Office Name",
    landmark: "Office Landmark /Notes",
    officeInfo: "Office Info",
    officeTypeLabel: "Office Type",
    requiredAddressLine1: "Office address line 1 cannot be empty.",
    requiredCity: "City field cannot be empty. Please select a city name.",
    requiredEmail: "Email field cannot be empty. Please enter a valid email.",
    requiredName: "Office name cannot be empty. Please enter a valid name.",
    requiredOfficeType: "Please select an Office Type.",
    requiredState: "State field cannot be empty. Please enter a state name.",
    requiredTelephone:
      "Office number cannot be empty. Please enter a telephone number.",
    requiredPhoneNumber: "Please enter a phone number.",
    requiredTimezone: "Timezone field cannot be empty.",
    requiredTitle: "Title field cannot be empty. Please enter a title.",
    requiredZipCode:
      "ZIP code field cannot be empty. Please enter a valid zip code.",
    stateLabel: "State/Region",
    telephoneLabel: "Office Telephone Number",
    canReceiveTextsLabel: "Able to receive text messages ?",
    canReceiveTextsInfo: "Select if you can receive texts at this number",
    contactPersonLabel: "Contact Name",
    contactPersonInfo:
      "DDS will use this contact name in the communications shared",
    officePhoneNumberInfo:
      "DDS will send all communications to this number, if it is marked to receive text messages.",
    phoneNumberLabel: "Office Mobile Number",
    titleLabel: "Title",
    typeDso: "DSO/DPO",
    typePrivate: "PP/Multi",
    zipCodeLabel: "Zip code",
    failedToFetchOfficeList: "Failed to fetch office list",
    none: "None",
    selectParentOffice: "Select Parent Office",
    officeInfoSuccess: "Office Info added successfully",
    officeTypeSelectOne: "Office Type (Select One)",
    numberOfLocations: "Number of Locations:",
    enterNumberOfLocations: "Enter number of locations",
    whichStates: "Which States",
    shareBrandName: "Do all offices share the same brand name?",
    websiteLink: "Website link",
    enterWebsiteLink: "Enter website link",
    explain: "Explain",
    parentOfficeLabel: "Parent Office:",
    pleaseSelectState: "Please select at least one state",
    clientOfficeName: "Client/office name",
    officeEmail: "Office email",
    linkedUserDetails: "Linked User Details",
    areYou: "Are you?",
    parent: "Parent",
    child: "Child",
  },
  provideShiftTime: "Please provide a valid shift start time and end time",
  practice: {
    howManyLabel: "how many practices are within your organization/DSO/DPO?",
    operatoriesLabel: "How many operatories?",
    requiredHowMany: "Please enter the practice count.",
    requiredOperatories: "Please enter the operatories count to continue.",
    typeDso: "DSO/DPO",
    typeLabel: "What type of practice?",
    typePrivate: "PP/Multi",
  },
  personalDetails: {
    labels: {
      addressOne: "Address Line 1",
      addressTwo: "Address Line 2",
      city: "City",
      clients: "Clients",
      email: "Email",
      employeeReferral: "Employee Referral",
      firstName: "First Name",
      howToHearAboutUs: "How did you hear about DDS?",
      jobBoards: "Job Boards",
      lastName: "Last Name",
      mobileNumber: "Mobile Number",
      practicingDate: "When did you start practicing",
      schoolName: "School Name",
      school: "School",
      securityAnswer: "Your security answer",
      securityQuestion: "Your security question",
      socialMedia: "Social Media",
      state: "State/Region",
      tradeShow: "Trade Show",
      zipCode: "Zip code",
    },
    errors: {
      addressOneRequired:
        "Address cannot be empty. Please enter a valid address.",
      addressTwoRequired:
        "Address cannot be empty. Please enter a valid address.",
      cityRequired: "Please select a valid option.",
      clientsRequired: "Please provide a valid answer.",
      emailPattern: "Invalid email! Please try again.",
      emailRequired: "Please provide your email.",
      employeeReferralRequired: "Please provide a valid answer.",
      firstNameRequired: "Please provide your first name.",
      howToHearAboutUsRequired: "Please select a valid option.",
      jobBoardsRequired: "Please select a valid option.",
      lastNameRequired: "Please provide your last name.",
      mobileNumberPattern: "Please enter a valid mobile number.",
      mobileNumberRequired:
        "Mobile number cannot be empty. Please enter the mobile number.",
      practicingDateRequired: "Please choose a date.",
      schoolNameRequired: "Please provide your school name.",
      schoolRequired: "Please select a valid option.",
      securityAnswerRequired: "Please provide your security answer.",
      securityQuestionRequired: "Please select your security question.",
      socialMediaRequired: "Please select a valid option.",
      stateRequired: "State field cannot be empty. Please enter a state name.",
      tradeShowRequired: "Please select a valid option.",
      zipCodeRequired:
        "ZIP code field cannot be empty. Please enter a valid zip code.",
      invalidName: "Please enter a valid name.",
      invalidSchoolName: "Please enter a valid school name.",
      invalidSecurityAnswer: "Please enter a valid security answer.",
    },
  },
  password: {
    emailInvalid: "Please enter a valid email id.",
    emailRequired: "Email field cannot be empty, please enter a valid mail id.",
    userName: "Username or Email address",
  },
  professionalLicense: {
    errors: {
      primaryRoleRequired: "Please select at least one primary role.",
    },
    labels: {
      primaryRole: "Select role",
      secondaryRole: "Select role",
    },
  },
  role: {
    admin: "Super Admin",
    confirmPassword: "Confirm Password",
    confirmPasswordRequired: "Confirm password is required",
    confirmPasswordMatch: "Confirm password does not match with password.",
    dso: "DSO/DPO",
    email: "Email",
    emailInvalid: "Please enter a valid email id.",
    emailRequired: "Email field cannot be empty, please enter a valid mail id.",
    job: "Job categories",
    jobCategories: "Job categories",
    jobRequired: "Please select at least one job category to continue.",
    module: "Module",
    name: "Name",
    nameRequired: "Name field cannot be empty, please enter user's name.",
    officeType: "Office type",
    officeTypeRequired: "Please select an office type to continue.",
    password: "Password",
    passwordRequired: "Password is required",
    passwordValid:
      "Must contain a minimum of 8 characters, 1 uppercase letter, 1 numeric digit & 1 special character.",
    private: "PP/Multi",
    removeUserMessage: "User removed successfully.",
    role: "Role",
    roleLabel: "Role",
    roleRequired: "Please select a role to continue.",
    saveMessage: "User creation has been completed successfully.",
    state: "State",
    stateOfOperation: "State of operation",
    type: "Type",
    updateMessage: "Changes saved successfully.",
  },
  skill: {
    errors: {
      prophyTimeRequired: "Please select a valid Prophy Time.",
    },
    labels: {
      prophyTime: "Prophy Time (DDS ADD on)",
      others: "Others",
    },
  },
  verify: "Verify",
  yes: "Yes",
  workHIstory: {
    errors: {
      officeRequired:
        "Office Name field cannot be empty. Please enter a office name.",
      positionRequired:
        "Position field cannot be empty. Please enter a position.",
      startDateRequired: "Please select your start date.",
      endDateRequired: "Please select your end date.",
      endDateValid: "End Date must be greater than Start Date",
      invalidOfficeName: "Please enter a valid office name.",
      invalidPosition: "Please enter a valid position.",
    },
    labels: {
      officeName: "Office Name",
      position: "Position",
      startDate: "Start Date",
      endDate: "End Date",
      currentCompany: "Current company work",
    },
  },
};
